/**
 * Constantes legales para componentes de la aplicación
 *
 * Centraliza datos legales del responsable del tratamiento
 * Reutilizable en PrivacyPolicy, TermsConditions y otros componentes legales
 *
 * @module utils/constants/legal
 */

/**
 * Datos del responsable del tratamiento de datos
 * Conforme a RGPD y LOPDGDD
 */
export const RESPONSABLE_TRATAMIENTO = {
  nombre: 'Dª Yolanda Moy Rodrigo',
  nif: '25178261-T',
  direccion: 'Plaza Roma, F1 - 2ª planta',
  codigoPostal: '50010',
  ciudad: 'Zaragoza',
  provincia: 'Zaragoza',
  pais: 'España',
  domicilio: 'Plaza Roma F1, 2ª planta, Zaragoza (España)',
  email: 'admin@olvidadme.com',
  emailSoporte: 'soporte@olvidadme.com',
  nombreComercial: 'OLVIDADME'
};

/**
 * Constantes de plazos legales de conservación de datos
 */
export const PLAZOS_CONSERVACION = {
  documentacionCaso: '5 años en bloqueo tras finalización',
  facturacion: '6 años',
  consentimientos: 'Mientras esté vigente + 5 años',
  cuentaUsuario: 'Hasta solicitud de baja + plazos legales'
};

/**
 * Referencias normativas principales
 */
export const NORMATIVA = {
  rgpd: 'Reglamento (UE) 2016/679 General de Protección de Datos',
  lopdgdd: 'Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales',
  articuloOlvido: 'Artículo 17 RGPD - Derecho de supresión',
  articuloPostMortem: 'Artículo 96 LOPDGDD - Personas fallecidas',
  codigoComercio: 'Artículo 30 del Código de Comercio'
};
